<template>
  <div
    class="bg-gray-4 mx-0 m-auto my-7 md:grid md:grid-cols-3 rounded-[15px] overflow-hidden"
  >
    <NuxtImg
      v-no-right-click
      class="w-full object-cover h-72 md:hidden"
      :src="supportImage"
      alt="support"
    />

    <div class="px-9 py-10">
      <h3 class="text-mobile-heading-2 md:text-heading-2 text-primary-1">
        {{ t("index.getSupport") }}
      </h3>
      <div class="text-mobile-heading-3 md:text-heading-3 text-secondary">
        24/7
      </div>
      <div class="text-mobile-paragraph-1 md:text-paragraph-1 text-gray-1 mt-3">
        {{ t("index.supportDescription") }}
      </div>
      <BaseButton
        type="third"
        color="primary-2"
        hover-background-color="white"
        hover-color="primary-2"
        :label="t('index.contactUs')"
        class="my-4"
        @click="router.push(localePath({ name: 'about' }))"
      />
    </div>
    <div class="col-span-2 relative h-[320px] max-md:hidden">
      <NuxtImg
        v-no-right-click
        class="w-full absolute object-cover h-full"
        :src="supportImage"
        alt="support"
      />
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const localePath = useLocalePath();
const { t } = useI18n();

const config = useRuntimeConfig();
const supportImageSrc = config.public.statics?.supportImgSrc || null;

const supportImage = computed(() => {
  return supportImageSrc ? supportImageSrc : "/support.png";
});
</script>
